import React, { Component } from 'react';

class IconActionDeleteBlue extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="none"
                viewBox="0 0 28 28"
            >
                <path
                    fill="#26A"
                    d="M23.473 8.57l-.188-1.16a3.011 3.011 0 00-1.005-1.798 2.932 2.932 0 00-1.913-.712h-1.29a3.15 3.15 0 00-.978-2.062A3.063 3.063 0 0016.001 2h-4.002c-.779 0-1.528.3-2.098.838A3.15 3.15 0 008.924 4.9H7.632c-.7 0-1.378.252-1.912.712A3.01 3.01 0 004.715 7.41l-.187 1.16a2.02 2.02 0 00.394 1.566 1.942 1.942 0 001.41.754l1.33 12.94c.015.55.23 1.076.602 1.476.373.4.878.647 1.419.694h8.634a2.196 2.196 0 001.419-.694c.373-.4.587-.926.602-1.476l1.33-12.94a1.942 1.942 0 001.41-.754 2.003 2.003 0 00.395-1.566zM11.998 4h4.002c.256 0 .505.09.704.254.199.164.337.392.39.646h-6.19a1.14 1.14 0 01.39-.646c.2-.164.448-.254.704-.254zM6.657 7.73c.04-.232.16-.443.34-.594a.985.985 0 01.635-.236h12.736c.232 0 .457.084.636.236.178.151.298.362.34.594l.187 1.17H6.469l.188-1.17zM9.762 24a.635.635 0 01-.138-.38L8.313 10.9h11.374l-1.31 12.72a.635.635 0 01-.139.38H9.762z"
                ></path>
            </svg>
        );
    }
}

export default IconActionDeleteBlue;